"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupWasmExtension = void 0;
var wasm_1 = require("./wasm");
Object.defineProperty(exports, "setupWasmExtension", { enumerable: true, get: function () { return wasm_1.setupWasmExtension; } });
//# sourceMappingURL=index.js.map